/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Empty_DescriptionInputs */

const en_blog_empty_description = /** @type {(inputs: Blog_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a different search or clear the filters.`)
};

const lv_blog_empty_description = /** @type {(inputs: Blog_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamēģiniet citu meklējumu vai notīriet filtrus.`)
};

/**
* | output |
* | --- |
* | "Try a different search or clear the filters." |
*
* @param {Blog_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_empty_description = /** @type {((inputs?: Blog_Empty_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Empty_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_empty_description(inputs)
	return en_blog_empty_description(inputs)
});